<!--
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-23 09:56:04
 * @LastEditTime: 2019-10-22 02:03:52
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="mine">
    <div class="header">
      <div class="message">
        <img class="head_icon"
             :src="accountData.avatar && accountData.avatar.length > 0?accountData.avatar:picUrl.defaultImage"
             alt="">
        <div class="head_head">
          <div class="head_name">{{accountData.nickName}}</div>
          <div v-if="accountData.hasMobile">
            <div v-if="!accountData.realSign"
                 class="head_real"
                 @click="navigateToReal(false)">未实名</div>
            <div v-else
                 class="head_real active"
                 @click="navigateToReal(true)">已实名</div>
          </div>
        </div>
        <router-link v-if="deviceType == 0"
                     to="modify"
                     class="head_arrow_icon"><img :src="picUrl.arrow_right"
               mode="scaleToFill"
               class="arrow_right_icon" /></router-link>
        <div class="head_phone">{{accountData.mobile}} <span v-if="userSpecialType && userSpecialType.length > 0">({{userSpecialType}})</span></div>
      </div>
      <div class="withdraw">
        <div class="title">可提战力</div>
        <div class="money">
          <span></span>{{accountData.availableWithdrawAmount}}</div>
        <div class="detail">
          <div class="left"><span>累计奖励</span>&nbsp;{{accountData.totalObtainAmount}}</div>
          <div class="left"
               @click="clickFreezeBtn">
            <div><span>冻结中</span>&nbsp;{{accountData.freezeAmount}}</div>
            <img :src="picUrl.iceIcon"
                 alt="">
          </div>
        </div>
        <div class="btn"
             @click="navigateToWithdraw">提战力</div>
      </div>
    </div>
    <div class="record">
      <div class="navi_bar">
        <div class="navi_bar_item"
             @click="navbarActiveIndex = 0">
          <div :class="{'active':navbarActiveIndex == 0}">奖励记录</div>
        </div>
        <div class="navi_bar_item"
             @click="navbarActiveIndex = 1">
          <div :class="{'active':navbarActiveIndex == 1}">提现记录</div>
        </div>
      </div>
      <div class="record_list">
        <div class="reward"
             v-if="navbarActiveIndex == 0 && rewardList && rewardList.length > 0">
          <div class="scroll_inner">
            <div class="reward_item"
                 v-for="(item, index) in rewardList"
                 :key="index">
              <img class="icon"
                   :src="item.avatar && item.avatar.length > 0?item.avatar:picUrl.defaultImage"
                   alt="">
              <div class="name">{{item.userName}}</div>
              <div class="time">{{item.prizeTime}}</div>
              <div class="type">{{popularizeMap[item.popularizeParticipantType]}}</div>
              <div v-if="item.isPositive"
                   class="money">+{{item.amount}}</div>
              <div v-else
                   class="money cancel">-{{item.amount}}</div>
            </div>
          </div>
        </div>
        <div class="cash"
             v-else-if="navbarActiveIndex == 1 && cashList && cashList.length > 0">
          <div class="scroll_inner">
            <div class="cash_item"
                 v-for="(item, index) in cashList"
                 :key="index">
              <div class="msg">提现至微信钱包</div>
              <div v-if="item.withdrawStatus == 'FAIL'"
                   class="tag">处理中</div>
              <div v-else
                   class="tag success">已到账</div>
              <div class="time">{{item.withdrawTime}}</div>
              <div class="money">{{item.amount}}元</div>
              <div class="money_detail">实际到账 {{item.toAccountAmount}}元</div>
            </div>
          </div>
        </div>
        <div class="empty"
             v-else>
          <div>暂无奖励记录</div>
        </div>
      </div>
    </div>
    <div class="tab_bar"
         v-if="deviceType == 0">
      <div class="tab_bar_item"
           @click="navigateToIndex">
        <img :src="picUrl.tabTaskDef"
             alt="">
        <span>星任务</span>
      </div>
      <div class="tab_bar_item">
        <img :src="picUrl.tabMeSel"
             alt="">
        <span class="active">我的星球</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency, jsonDateFormat, appCertificationClick } from '@/utils/index.js'
export default {
  name: 'mine',
  data () {
    return {
      picUrl: {
        tabTaskDef: this.$store.state.ossLink + 'icon_task_def.png',
        tabTaskSel: this.$store.state.ossLink + 'icon_task_sel.png',
        tabMeDef: this.$store.state.ossLink + 'icon_me_def.png',
        tabMeSel: this.$store.state.ossLink + 'icon_me_sel.png',
        iceIcon: this.$store.state.ossLink + 'share/share_icon_explain.png',
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
        arrow_right: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/designerClub/icon/ic_right_arrow_grey@3x.png'
      },
      popularizeMap: {
        ENROLL: '报名',
        ORDER: '下单',
        USE_COUPON: '用券',
        READ: '阅读',
        ALTER_ORDER: '改单',
        CANCEL_ORDER: '退单',
        SIGN_IN: '签到',
        RETURN_COUPON: '退券',
        WATCH_LIVE: '观看直播'
      },
      accountData: {},
      navbarActiveIndex: 0,
      rewardList: [],
      cashList: [],
      userSpecialType: '',
      deviceType: 0 // 设备类型
    }
  },
  methods: {
    navigateToIndex () {
      this.$router.push('/activity')
    },
    clickFreezeBtn () {
      this.$weui.dialog({
        title: '提示',
        content: '冻结金额为好友成功下单奖励金额，冻结时间内不可以提现哦，解冻就可以提取到微信零钱包啦！',
        className: 'custom-classname',
        buttons: [{
          label: '知道了',
          type: 'primary',
          onClick: function () {
            console.log('ok')
          }
        }]
      })
    },
    navigateToWithdraw () {
      let self = this
      if (!self.accountData.hasMobile) {
        self.$weui.dialog({
          title: '提示',
          content: '星客联盟需要验证您的手机号',
          className: 'custom-classname',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          }, {
            label: '确定',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              let locationHref = window.location.href
              self.$router.push({path: '/login', query: {fromurl: locationHref}})
            }
          }]
        })
        return
      }
      if (!self.accountData.realSign) {
        self.$weui.dialog({
          title: '提示',
          content: '通过实名认证后才可进行提现操作',
          className: 'custom-classname',
          buttons: [{
            label: '取消',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          }, {
            label: '实名认证',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              self.navigateToReal(false)
            }
          }]
        })
        return
      }
      this.$router.push('/withdraw')
    },
    navigateToReal (val) {
      if (val) { // 如果已实名
        if (this.deviceType === 0) { // 如果在微信中打开跳实名信息页面，APP打开不做任务跳转
          this.$router.push('/certificationDetail')
        }
      } else { // 如果未实名
        if (this.deviceType === 0) { // 如果在微信中打开跳实名认证页面
          this.$router.push('/certification')
        } else { // 如果在APP中打开跳APP备案页面
          appCertificationClick()
        }
      }
    },
    /**
     * /h5/star/alliance2/star/guest/account/total/obtain/my/account
     * 总的个人账户信息
     */
    getMyAccount () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            res.data.availableWithdrawAmount = parseInt(res.data.availableWithdrawAmount * 100)
            res.data.totalObtainAmount = parseInt(res.data.totalObtainAmount * 100)
            res.data.freezeAmount = parseInt(res.data.freezeAmount * 100)
            if (res.data.starGuestType && res.data.starGuestType === 'CLERK') {
              self.userSpecialType = '商户'
            } else if (res.data.starGuestType && res.data.starGuestType === 'STAFF') {
              self.userSpecialType = '员工'
            } else {
              self.userSpecialType = ''
            }
            self.accountData = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
    * /h5/star/alliance2/star/guest/participant/record/share/obtain/prize/record
    * 分享赚现金奖励记录
    */
    shareObtainMyAccount () {
      let self = this
      self.$fly
        .request({
          url: '/h5/star/alliance2/star/guest/participant/record/share/obtain/prize/record',
          params: {
            popularizeNo: '',
            pageNo: 1,
            pageSize: 9999
          }
        })
        .then(res => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.isPositive = item.amount > 0
              item.amount = parseInt(item.amount * 100)
              item.prizeTime = jsonDateFormat(item.prizeTime, 'minute1')
            })
            self.rewardList = res.data.list
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
    * /h5/star/alliance2/star/guest/star/guest/withdraw/page
    * 星客提现记录分页
    */
    starGuestWithdrawPage () {
      let self = this
      self.$fly
        .request({
          url: '/h5/star/alliance2/star/guest/star/guest/withdraw/page',
          params: {
            pageNo: 1,
            pageSize: 9999
          }
        })
        .then(res => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.amount = formatCurrency(item.amount)
              item.toAccountAmount = formatCurrency(item.toAccountAmount)
              item.withdrawTime = jsonDateFormat(item.withdrawTime, 'minute2')
            })
            self.cashList = res.data.list
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     *
     */
    wxShare () {
      let self = this
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem'
              ]
            })
            self.$wx.ready(function () {
              // 隐藏分享
              self.$wx.hideAllNonBaseMenuItem()
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  activated () {
    let self = this
    this.deviceType = parseInt(localStorage.getItem('USER_DEVICE_TYPE'))
    if (self.$route.query.token) {
      localStorage.setItem('STAR_GUEST_TOKEN', self.$route.query.token)
    }
    this.getMyAccount()
    // if (this.deviceType === 0) { this.wxShare() }
    this.shareObtainMyAccount()
    this.starGuestWithdrawPage()
  },
  mounted () { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#mine {
  width: 100%;
}
.header {
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  height: 613px;
  background-color: #fff;
}
.header .message {
  position: absolute;
  left: 20px;
  top: 0;
  height: 193px;
  width: calc(100% - 40px);
  border-bottom: 1px solid #f0f0f0; /* no */
  .head_icon {
    position: absolute;
    left: 0;
    top: 40px;
    width: 113px;
    height: 113px;
    border-radius: 50%;
  }
  .head_head {
    position: absolute;
    left: 160px;
    top: 46px;
    font-size: 36px;
    color: #333333;
    width: 100%;
    .head_name {
      display: block;
      float: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 280px);
    }
    .head_real {
      display: block;
      float: left;
      margin-left: 20px;
      margin-top: 12px;
      line-height: 22px;
      font-size: 22px;
      color: #999999;
      padding: 6px 10px;
      border-radius: 10px;
      border: solid 1px #999999; /* no */
    }
    .active {
      background-color: #fe5f5e;
      color: #fff;
      border: solid 1px #fe5f5e; /* no */
    }
  }
  .head_phone {
    position: absolute;
    left: 160px;
    top: 100px;
    font-size: 28px;
    color: #999999;
  }
  .head_arrow_icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 100px;
    text-align: right;
    .arrow_right_icon {
      height: 30px;
      width: 16px;
      margin-top: 1.1rem;
      display: inline-block;
    }
  }
}
.header .withdraw {
  position: absolute;
  left: 0;
  bottom: 0;
  top: 193px;
  width: 100%;
  .title {
    position: absolute;
    left: 0;
    top: 40px;
    width: 100%;
    line-height: 30px;
    text-align: center;
    font-size: 30px;
    color: #000000;
  }
  .money {
    position: absolute;
    left: 0;
    top: 115px;
    width: 100%;
    line-height: 60px;
    text-align: center;
    font-size: 60px;
    color: #ff000c;
    span {
      font-size: 36px;
    }
  }
  .detail {
    position: absolute;
    top: 218px;
    left: calc(50% - 304px);
    width: 608px;
    font-size: 28px;
    height: 28px;
    line-height: 28px;
    .left {
      display: flex;
      width: 50%;
      float: left;
      justify-content: center;
      align-items: center;
      color: #333333;
      div {
        display: block;
        float: left;
      }
      span {
        color: #999999;
      }
      img {
        margin-left: 10px;
        display: block;
        float: left;
        width: 28px;
        height: 28px;
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 52px;
    width: 608px;
    height: 88px;
    left: calc(50% - 304px);
    line-height: 88px;
    background-color: #fb4e2d;
    border-radius: 10px;
    font-size: 36px;
    text-align: center;
    color: #ffffff;
  }
}
.record {
  position: fixed;
  left: 0;
  width: 100%;
  top: 633px;
  bottom: 101px;
  background-color: #fff;
  .navi_bar {
    position: absolute;
    top: 0;
  }
  .record_list {
    position: absolute;
    top: 100px;
    left: 0;
    width: 100%;
    bottom: 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .reward {
      .reward_item {
        margin-left: 20px;
        width: calc(100% - 40px);
        position: relative;
        height: 140px;
        border-bottom: 1px solid #f0f0f0; /* no */
        .icon {
          position: absolute;
          left: 0;
          top: 35px;
          width: 66px;
          height: 66px;
          border-radius: 50%;
        }
        .name {
          position: absolute;
          left: 109px;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          top: 35px;
          font-size: 28px;
          line-height: 28px;
          color: #333333;
        }
        .time {
          position: absolute;
          left: 106px;
          top: 79px;
          font-size: 26px;
          line-height: 26px;
          color: #999999;
        }
        .type {
          position: absolute;
          left: 417px;
          top: 55px;
          font-size: 26px;
          line-height: 26px;
          color: #333333;
        }
        .money {
          position: absolute;
          right: 3px;
          top: 56px;
          font-size: 32px;
          line-height: 32px;
          color: #ff000c;
        }
        .cancel {
          color: #1ed7b2;
        }
      }
    }
    .cash {
      .cash_item {
        margin-left: 20px;
        width: calc(100% - 40px);
        position: relative;
        height: 140px;
        border-bottom: 1px solid #f0f0f0; /* no */
        .msg {
          position: absolute;
          left: 0;
          top: 39px;
          font-size: 28px;
          line-height: 28px;
          color: #333333;
        }
        .tag {
          position: absolute;
          left: 204px;
          top: 40px;
          border-radius: 6px;
          border: solid 1px #999999; /* no */
          padding: 5px;
          text-align: center;
          line-height: 20px;
          font-size: 20px;
          color: #999999;
        }
        .success {
          color: #fff;
          background-color: #1ed7b2;
          border: solid 1px #1ed7b2; /* no */
        }
        .time {
          position: absolute;
          left: 0;
          top: 82px;
          font-size: 26px;
          line-height: 26px;
          color: #999999;
        }
        .money {
          position: absolute;
          right: 0;
          top: 43px;
          font-family: PingFang-SC-Bold;
          line-height: 28px;
          font-size: 28px;
          color: #ff000c;
        }
        .money_detail {
          position: absolute;
          right: 4px;
          top: 85px;
          font-size: 20px;
          line-height: 20px;
          color: #999999;
        }
      }
    }
    .empty {
      margin-top: 145px;
      text-align: center;
      width: 100%;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/mine.vue